import { render, staticRenderFns } from "./setTextPush.vue?vue&type=template&id=31878cbb&scoped=true&"
import script from "./setTextPush.vue?vue&type=script&lang=js&"
export * from "./setTextPush.vue?vue&type=script&lang=js&"
import style0 from "./setTextPush.vue?vue&type=style&index=0&id=31878cbb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31878cbb",
  null
  
)

export default component.exports